export const getWarmupKeyForOldPostPage = (postSlug: string) => {
  return `OldPostPageWarmupData-${postSlug}`;
};
